import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Slide,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { API } from "aws-amplify";

import { LoadingSpinner } from "../../../../utils/LoadingSpinner";
import { TransitionProps } from "@material-ui/core/transitions";
import ExpeditedEnrollmentResult from "../expedited_enrollment/ExpeditedEnrollmentResult";
import OMSpecificSection from "../expedited_enrollment/OMSpecificSection";
import BSCASpecificSection from "../expedited_enrollment/BSCASpecificSection";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

enum ThirdPartyCustomerType {
  ONE_MEDICAL_CUSTOMER,
  BSCA,
}

interface IThirdPartyCustomerProps
  extends WithStyles<typeof styles>,
    RouteComponentProps {
  opt?: any;
}

interface IThirdPartyCustomerState {
  buttonVariantForOneMedicalCustomer: any;
  buttonVariantForBSCACustomer: any;
  customer: any;
  getThirdPartyCustomer: boolean;
  message: string;
  open: boolean;
  referenceIdentifierToken: any;
  showFieldsForOneMedicalCustomer: boolean;
  showFieldsForBSCACustomer: boolean;
}

class ThirdPartyCustomer extends React.Component<
  IThirdPartyCustomerProps,
  IThirdPartyCustomerState
> {
  private omSpecificSection: any;
  private bscaSpecificSection: any;

  constructor(props: IThirdPartyCustomerProps) {
    super(props);
    this.state = {
      buttonVariantForBSCACustomer: "outlined",
      buttonVariantForOneMedicalCustomer: "outlined",
      customer: "",
      getThirdPartyCustomer: true,
      message: "",
      open: false,
      referenceIdentifierToken: "",
      showFieldsForBSCACustomer: false,
      showFieldsForOneMedicalCustomer: false,
    };
    this.handleSubmitBSCA = this.handleSubmitBSCA.bind(this);
    this.handleSubmitOneMedical = this.handleSubmitOneMedical.bind(this);
    this.showFieldsForBSCACustomer = this.showFieldsForBSCACustomer.bind(this);
    this.showFieldsForOneMedicalCustomer =
      this.showFieldsForOneMedicalCustomer.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  public render() {
    return (
      <div style={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3} justify="center">
              <Grid item xs>
                <Button
                  variant={this.state.buttonVariantForOneMedicalCustomer}
                  color="default"
                  fullWidth
                  onClick={this.showFieldsForOneMedicalCustomer}
                  style={{ padding: "3px" }}
                >
                  One Medical Customer
                </Button>
              </Grid>
              <Grid item xs>
                <Button
                  variant={this.state.buttonVariantForBSCACustomer}
                  color="default"
                  fullWidth
                  onClick={this.showFieldsForBSCACustomer}
                  style={{ padding: "3px" }}
                >
                  BSCA Customer
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {this.state.showFieldsForOneMedicalCustomer && (
            <OMSpecificSection ref={(ref) => (this.omSpecificSection = ref)} />
          )}

          {this.state.showFieldsForOneMedicalCustomer && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitOneMedical}
                  >
                    Create One Medical enrollment url
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.showFieldsForBSCACustomer && (
            <BSCASpecificSection
              ref={(ref) => (this.bscaSpecificSection = ref)}
            />
          )}

          {this.state.showFieldsForBSCACustomer && (
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs>
                  <Button
                    variant="outlined"
                    color="default"
                    onClick={this.handleSubmitBSCA}
                  >
                    Create BSCA enrollment URL
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            {!this.state.getThirdPartyCustomer && <LoadingSpinner />}
            {this.state.referenceIdentifierToken && (
              <ExpeditedEnrollmentResult
                referenceIdentifierToken={this.state.referenceIdentifierToken}
                heading={"Reference Identifier Token"}
              />
            )}
          </Grid>

          {this.state.message && (
            <Dialog
              open={this.state.open}
              TransitionComponent={TransitionConst}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              onClose={this.handleClose}
            >
              <DialogTitle id="alert-dialog-slide-title">
                {"Exception occurred when creating pharmacy customer"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {this.state.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      </div>
    );
  }

  private handleClose() {
    this.setState({ open: false });
  }

  private showFields(createPharmacyCustomerType: ThirdPartyCustomerType) {
    switch (createPharmacyCustomerType) {
      case ThirdPartyCustomerType.ONE_MEDICAL_CUSTOMER: {
        this.setState({ showFieldsForOneMedicalCustomer: true });
        this.setState({ showFieldsForBSCACustomer: false });

        this.setState({ buttonVariantForOneMedicalCustomer: "contained" });
        this.setState({ buttonVariantForBSCACustomer: "outlined" });

        break;
      }
      case ThirdPartyCustomerType.BSCA: {
        this.setState({ showFieldsForBSCACustomer: true });
        this.setState({ showFieldsForOneMedicalCustomer: false });

        this.setState({ buttonVariantForBSCACustomer: "contained" });
        this.setState({ buttonVariantForOneMedicalCustomer: "outlined" });

        break;
      }
      default: {
        break;
      }
    }
    this.setStateToBlank();
  }

  private setStateToBlank() {
    this.setState({ referenceIdentifierToken: "" });
  }

  private showFieldsForOneMedicalCustomer() {
    this.showFields(ThirdPartyCustomerType.ONE_MEDICAL_CUSTOMER);
  }

  private showFieldsForBSCACustomer() {
    this.showFields(ThirdPartyCustomerType.BSCA);
  }

  private handleSubmitOneMedical() {
    this.setState({ getThirdPartyCustomer: false });

    const apiName = "ApaqPortalAPI";
    const path = "/health-customer/generate-enrollment-url";
    const config = {
      body: {
        addressLine1: this.omSpecificSection.getCommonFieldsSection().getState()
          .addressLine1,
        addressLine2: this.omSpecificSection.getCommonFieldsSection().getState()
          .addressLine2,
        biologicalSex: this.omSpecificSection
          .getCommonFieldsSection()
          .getState().biologicalSex,
        city: this.omSpecificSection.getCommonFieldsSection().getState().city,
        country: this.omSpecificSection.getCommonFieldsSection().getState()
          .country,
        countryCode: this.omSpecificSection.getCommonFieldsSection().getState()
          .countryCode,
        dateOfBirth: this.omSpecificSection.getCommonFieldsSection().getState()
          .dateOfBirth,
        emailId: this.omSpecificSection.getCommonFieldsSection().getState()
          .emailId,
        externalClientReference:
          this.omSpecificSection.getState().externalClientReference,
        firstName: this.omSpecificSection.getCommonFieldsSection().getState()
          .firstName,
        healthExternalFHIRId:
          this.omSpecificSection.getState().healthExternalFHIRId,
        lastName: this.omSpecificSection.getCommonFieldsSection().getState()
          .lastName,
        middleName: this.omSpecificSection.getCommonFieldsSection().getState()
          .middleName,
        mobileNumber: this.omSpecificSection.getCommonFieldsSection().getState()
          .mobileNumber,
        preferredGender: this.omSpecificSection
          .getCommonFieldsSection()
          .getState().preferredGender,
        preferredName: this.omSpecificSection
          .getCommonFieldsSection()
          .getState().preferredName,
        preferredPronoun: this.omSpecificSection
          .getCommonFieldsSection()
          .getState().preferredPronoun,
        programToEnroll: this.omSpecificSection
          .getCommonFieldsSection()
          .getState().programToEnroll,
        sexAtBirth: this.omSpecificSection.getCommonFieldsSection().getState()
          .sexAtBirth,
        state: this.omSpecificSection.getCommonFieldsSection().getState().state,
        suffix: this.omSpecificSection.getCommonFieldsSection().getState()
          .suffix,
        zipCode: this.omSpecificSection.getCommonFieldsSection().getState()
          .zipCode,
      },
      headers: {},
    };

    this.callAPI(apiName, path, config);
  }

  private handleSubmitBSCA() {
    this.setState({ getThirdPartyCustomer: false });

    const apiName = "ApaqPortalAPI";
    const path = "/health-customer/generate-enrollment-url";
    const config = {
      body: {
        addressLine1: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().addressLine1,
        addressLine2: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().addressLine2,
        biologicalSex: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().biologicalSex,
        city: this.bscaSpecificSection.getCommonFieldsSection().getState().city,
        country: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .country,
        countryCode: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().countryCode,
        dateOfBirth: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().dateOfBirth,
        emailId: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .emailId,
        enrollmentPartner:
          this.bscaSpecificSection.getState().enrollmentPartner,
        externalClientReference:
          this.bscaSpecificSection.getState().externalClientReference,
        firstName: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .firstName,
        healthInsuranceDetailsList:
          this.bscaSpecificSection.getHealthInsurancesList(),
        lastName: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .lastName,
        middleName: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .middleName,
        mobileNumber: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().mobileNumber,
        preferredGender: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().preferredGender,
        preferredName: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().preferredName,
        preferredPronoun: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().preferredPronoun,
        programToEnroll: this.bscaSpecificSection
          .getCommonFieldsSection()
          .getState().programToEnroll,
        sexAtBirth: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .sexAtBirth,
        state: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .state,
        suffix: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .suffix,
        zipCode: this.bscaSpecificSection.getCommonFieldsSection().getState()
          .zipCode,
      },
      headers: {},
    };

    this.callAPI(apiName, path, config);
  }

  private callAPI(apiName: string, path: string, config: any) {
    this.setState({ customer: "" });

    API.post(apiName, path, config)
      .then((value: any) => {
        console.log(value);
        console.log(value.referenceIdentifierToken);

        this.setState({ referenceIdentifierToken: value });

        // this.setState({customer: value})
        this.setState({ getThirdPartyCustomer: true });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ getThirdPartyCustomer: true });
        this.setState({ open: true });
        this.setState({ message: error.response.data.message });
      });

    this.setState({ getThirdPartyCustomer: false });
  }
}

export default withStyles(styles)(ThirdPartyCustomer);
